<template>
    <div class="demo-spin-article">

        <Row type="flex" justify="space-between" style="padding-top: 5px" class="mb-30">

            <Col :sm="24" :xs="24" :md="24" :lg="0">
                <Row type="flex" :gutter="24">
                    <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
                        <Button class="w-lg-100" type="info" :disabled="disabledReport" @click="downloadReport()">
                            Скачать отчет
                        </Button>
                    </Col>
                    <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
                        <Select
                                v-model="selectReport"
                                class="w-lg-100"
                                clearable
                                placeholder="Список отчетов">
                            <Option value="period_wirehouse">
                                Остатки на складе
                            </Option>
                            <Option value="period_order">
                                Закуп и реализация товаров
                            </Option>
                            <Option value="period_report">
                                Бизнес отчет за период
                            </Option>
                            <Option value="period_payment">
                                Продажи по форме оплаты
                            </Option>
                            <Option v-if="isNoFiscalPressed"
                                value="period_noFiscal_payment">
                                Продажи по форме оплаты (нефискальные)
                            </Option>
                        </Select>
                    </Col>
                    <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
                        <Select
                                class="w-lg-100"
                                placeholder="Список кассиров"
                                v-model="filterCashier"
                                @on-select="selectFilterCashier"
                        >
                            <Option
                                    v-if="item.role === 'cashier'"
                                    v-for="item in user"
                                    :value="item.id"
                                    :key="item.id"
                            >
                                {{ item.full_name }}

                            </Option
                            >
                        </Select>
                    </Col>
                    <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
                        <Select
                                v-model="filterStore"
                                class="w-lg-100"
                                placeholder="Список магазинов"
                                @on-select="selectFilterStore"
                        >
                            <Option

                                    v-for="item in store"
                                    :value="item.id"
                                    :key="item.id"
                            >
                                {{ item.name }}

                            </Option
                            >
                        </Select>
                    </Col>
                    <!-- <col class="top__button"> -->
                    <template>
                        <Tooltip :content="nonfiscal_tooltip"
                            placement="right">
                            <button type="primary" class="noFiscalButton"
                                :class="{ pressed: isNoFiscalPressed }" 
                                @click="isClicked()">
                                <img src="/static/svg/cash.svg" alt="Button icon" />
                            </button>
                        </Tooltip>
                    </template>
                </Row>
            </Col>


            <Col :sm="24" :xs="24" :md="24" :lg="0">
                <DatePicker
                        v-model="filterDate"
                        @on-change="selectFilterDate"
                        :start-date="currentDate"
                        format="yyyy-MM-dd"
                        :type="daterange"
                        placeholder="Дата документа"

                ></DatePicker>
            </Col>

        </Row>


        <div class="mb-30" v-if="showClearFilter">
            <Button
                    @click="clearFilter"
                    type="error"
            >Сбросить фильтр
            </Button>
        </div>

        <Row :gutter="20" type="flex" class="mb-30 cards">
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container box box-1">
                    <h3>Выручка</h3>
                    <h2 v-if="details.total_sell">{{formatNumber(details.total_sell)}} {{currency}}</h2>
                    <p v-else>Нет данных</p>

                </div>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container box box-2">
                    <h3>Себестоимость</h3>
                    <h2 v-if="details.total_purchase">{{formatNumber(details.total_purchase)}} {{currency}}</h2>
                    <p v-else>Нет данных</p>
                </div>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container box box-3">
                    <h3>Прибыль</h3>
                    <h2 v-if="details.profit">{{formatNumber(details.profit)}} {{currency}}</h2>
                    <p v-else>Нет данных</p>
                </div>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container box box-4">
                    <h3>Средний чек </h3>
                    <h2 v-if="details.average_ticket">{{formatNumber(details.average_ticket)}} {{currency}}</h2>
                    <p v-else>Нет данных</p>
                </div>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container">
                    <h3>Рентабельность</h3>
                    <h2 v-if="details.profitability">{{formatNumber(details.profitability)}}%</h2>
                    <p v-else>Нет данных</p>
                </div>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" class="mb-10">
                <div class="card-container">
                    <h3>Маржинальность</h3>
                    <h2 v-if="details.marginality">{{formatNumber(details.marginality)}}%</h2>
                    <p v-else>Нет данных</p>
                </div>
            </Col>
        </Row>


        <!--    <Row>-->
        <!--      <Menu-->
        <!--        mode="horizontal"-->
        <!--        :active-name="defaultFilter"-->
        <!--        @on-select="selectFilter"-->
        <!--        style="line-height: 0; height: 30px"-->
        <!--      >-->
        <!--        <MenuItem name="year" class="menu-item">-->
        <!--          Год-->
        <!--        </MenuItem>-->
        <!--        <MenuItem name="month" class="menu-item">-->
        <!--          Месяц-->
        <!--        </MenuItem>-->
        <!--        <MenuItem name="week" class="menu-item">-->
        <!--          Неделя-->
        <!--        </MenuItem>-->
        <!--        <MenuItem name="day" class="menu-item">-->
        <!--          День-->
        <!--        </MenuItem>-->
        <!--      </Menu>-->
        <!--    </Row>-->


        <Row class="mb-50 graph-container">
            <h2>Выручка</h2>
            <reportRevenueBarChart :data="data" style="margin-top: 20px"></reportRevenueBarChart>
        </Row>


        <Row class="mb-50 graph-container">
            <Col :xxl="12">
                <h2>Оплаты</h2>


                <div v-if="displayChart">
                    <paymentType :labels="labels" :data="dataPayment" style="margin-top: 20px" :height="330"
                                 :width="330"></paymentType>
                    <Row style="margin-top: 20px">
                        <Col span="12">
                            <div
                                    class="box-count-label"
                                    v-for="(label, index) in labels"
                                    :key="label"
                            >
                                <div
                                        class="box-count-circle"
                                        :style="{
                background: backgroundColor[index]
              }"
                                ></div>
                                {{ label }}
                            </div>
                        </Col>
                        <Col span="12">
                            <div
                                    v-if="dataPayment"
                                    class="box-count-value"
                                    v-for="(val, index) in dataPayment"
                                    :key="val"
                            >{{ formatPaymentNumber(val)}} {{ $store.state.currency }}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div v-else class="box-no-data">
                    Нет данных для отображения
                </div>

                <Spin size="large" fix v-if="loading"></Spin>
            </Col>
        </Row>


        <Row>
            <h2 class="mb-50">Топ 10 товаров</h2>
            <div v-if="displayTable" class="desktop_table">
                <Row class="box-table-header">
                    <Col span="7" style="text-align: left">Наименование</Col>
                    <Col span="4">Цена</Col>
                    <Col span="4">Кол-во</Col>
                    <Col span="5">Выручка</Col>
                    <!--        <Col span="4">Рентабельность</Col>-->
                    <Col span="4">Маржинальность</Col>
                </Row>

                <Row class="box-table-row" v-for="item in dataProducts">
                    <Col span="7" style="text-align: left"> {{formatShortText(item.name)}}</Col>
                    <Col span="4">{{formatNumber(item.average_price)}} {{ $store.state.currency }}</Col>
                    <Col span="4">{{formatNumber(item.total_count)}}</Col>
                    <Col span="5">{{formatNumber(item.total_sum)}} {{ $store.state.currency }}</Col>
                    <Col span="4">{{formatNumber(item.marginality)}} %</Col>
                </Row>
            </div>
            <div v-else class="box-no-data">
                Нет данных для отображения
            </div>


            <!-- DATA MOBILE TABLE -->
            <div class="mobile-table">

                <div v-for="item in dataProducts" class="card-container">
                    <div>
                        <h2>{{item.name}}</h2>
                        <p>Цена: {{formatNumber(item.average_price)}} {{ $store.state.currency }}</p>
                        <p>Кол-во: {{formatNumber(item.total_count)}}</p>
                        <p>Маржинальность: {{formatNumber(item.marginality)}} %</p>
                    </div>

                    <div>
                        <p class="price">{{formatNumber(item.total_sum)}} {{ $store.state.currency }}</p>
                    </div>

                </div>
            </div>
        </Row>

        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>

    import {base_url, server_addr} from "../../http.js";
    import {BaseFormData} from "../../base/base_form_v2.js";

    import reportRevenueBarChart from "@/apps/report/reportRevenueBarChart";
    import topProducts from "@/apps/report/topProducts.vue";
    import paymentType from "@/apps/report/paymentType";


    let base = BaseFormData();

    base.components = {
        topProducts,
        reportRevenueBarChart,
        paymentType
    };

    base.data = function () {
        return {
            loading: true,
            isNoFiscalPressed: false,
            nonfiscal_tooltip: 'Показать нефискальный отчет',
            user: [],
            store: [],
            details: [],

            totalAverageOrder: '',
            showClearFilter: false,

            data: [],
            labels: [],
            dataPayment: [],
            dataProducts: [],
            backgroundColor: [
                "#FFDA83",
                '#FF8373',
                '#55D8FE'
            ],

            filterDate: [],
            filterCashier: '',
            filterStore: '',
            // filter: {
            //     date: [],
            //     cashier: "",
            //     store: ""
            // },

            disabledReport: true,
            selectReport: ''

        };
    };

    base.computed.currentDate = function(){
      let date = new Date();
      if (this.selectReport !== 'period_wirehouse') {
        date.setMonth(date.getMonth() - 1);
      }
      return date;
    };


    base.methods.getUsers = function () {
        const url = base_url + "/users/";
        this.$http
            .get(url)
            .then(result => {
                this.user = result.data.results;
            })
    };
    base.methods.getStore = function () {
        const url = base_url + "/stores/";
        this.$http
            .get(url)
            .then(result => {
                this.store = result.data.results;
            })
    };

    base.methods.getTotalCounts = function () {
        const url = base_url + "/charts/average_order/";
        this.$http
            .get(url)
            .then(result => {
                this.totalAverageOrder = result.data.average_sum;
            })
    };


    base.methods.selectFilterCashier = function (cashier) {
        this.fetchRevenue(cashier, this.filterStore, this.filterDate);
        this.fetchPayments(cashier, this.filterStore, this.filterDate);
        this.fetchProducts(cashier, this.filterStore, this.filterDate);
        this.getDetails(cashier, this.filterStore, this.filterDate);
        this.showClearFilter = true;
    };
    base.methods.selectFilterStore = function (store) {
        this.fetchRevenue(this.filterCashier, store, this.filterDate);
        this.fetchPayments(this.filterCashier, store, this.filterDate);
        this.fetchProducts(this.filterCashier, store, this.filterDate);
        this.getDetails(this.filterCashier, store, this.filterDate);
        this.showClearFilter = true;
        // this.isValidPoints(this.filter.date, store);
    };
    base.methods.selectFilterDate = function (date) {
        if (date.length === 2) {
            let dateString_0 = date[0];
            let dateString_1 = date[1];
            let date_0 = new Date(dateString_0);
            let date_1 = new Date(dateString_1);

            this.filterDate[0] = date_0.toLocaleDateString("fr-CA");
            this.filterDate[1] = date_1.toLocaleDateString("fr-CA");
        }
        else {
            let dateString_0 = date;
            let date_0 = new Date(dateString_0);
            this.filterDate = date_0.toLocaleDateString("fr-CA");
        }


        this.fetchRevenue(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchPayments(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchProducts(this.filterCashier, this.filterStore, this.filterDate);
        this.getDetails(this.filterCashier, this.filterStore, this.filterDate);
        this.showClearFilter = true;

        // this.isValidPoints(date, this.filter.store);
    };


    base.methods.clearFilter = function () {
        this.showClearFilter = false;
        this.filterDate = ['', ''];
        this.filterCashier = '';
        this.filterStore = '';
        this.selectReport = '';
        this.fetchRevenue(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchPayments(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchProducts(this.filterCashier, this.filterStore, this.filterDate);
        this.getDetails(this.filterCashier, this.filterStore, this.filterDate);
        this.isValidPoints(this.filterDate, this.filterStore);
    };

    base.methods.getDetails = function (cashier, store, date) {
        const url = base_url + "/charts/common/";
        this.$http
            .get(url, {
                params: {cashier: cashier, store: store, date_from: date[0], date_to: date[1]}
            })
            .then(url => {
                this.details = url.data;
            })
            .catch(error => {
                if (error) {
                    this.details = [];
                }
            })
    };

    base.methods.fetchRevenue = function (cashier, store, date) {
        this.loading = true;
        let url = `${base_url}/charts/revenue_bar/`;
        this.$http
            .get(url, {
                params: {cashier: cashier, store: store, date_from: date[0], date_to: date[1]}
            })
            .then(result => {
                this.data = result.data;
            })
            .finally(() => {
                this.loading = false;
            });
    };
    base.methods.fetchPayments = function (cashier, store, date) {
        this.loading = true;
        let url = `${base_url}/charts/payment_type/`;
        this.$http
            .get(url, {
                params: {cashier: cashier, store: store, date_from: date[0], date_to: date[1]}
            })
            .then(result => {
                this.labels = [];
                this.dataPayment = [];
                result.data.forEach(product => {
                    if (product.type == 'Payment type cash') {
                      this.labels.push("Наличные");
                    } else if (product.type == 'Payment type card') {
                      this.labels.push("Карта");
                    } else if (product.type == 'Payment type mobile') {
                      this.labels.push("Мобильные");
                    } else {
                      this.labels.push(product.type);
                    }
                    this.dataPayment.push(product.sum);
                });
            })
            .finally(() => {
                this.loading = false;
            });
    };
    base.methods.fetchProducts = function (cashier, store, date) {
        this.loading = true;
        let url = `${base_url}/charts/top_products/?size=10`;
        this.$http
            .get(url, {
                params: {cashier: cashier, store: store, date_from: date[0], date_to: date[1]}
            })
            .then(result => {
                this.dataProducts = result.data;
            })
            .finally(() => {
                this.loading = false;
            });
    };


    base.methods.formatNumber = function (val) {
        if (val) {
            return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        }
    };

    base.methods.formatPaymentNumber = function (val) {
        if (val || val >= 0) {
            return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        }
    };


    base.methods.formatShortText = function (text) {
        if (text.length > 50) {
            return text.slice(0, 50) + '...';
        } else
            return text;
    };

    base.methods.isClicked = function () {
        this.isNoFiscalPressed = !this.isNoFiscalPressed
        if (this.isNoFiscalPressed) {
            this.nonfiscal_tooltip = 'Скрыть нефискальный отчет'
        }
        else {
            this.nonfiscal_tooltip = 'Показать нефискальный отчет'
        }
        return;
    };


    base.methods.isValidPoints = function (date, store) {

        if (this.selectReport && date[0] && date[1]) {
            this.disabledReport = false;
        } else {
            this.disabledReport = true
        }

    };

    base.methods.downloadReport = function () {
        this.loading = true;
        let url;

        if (this.selectReport === 'period_wirehouse') {
            url = server_addr + '/api/v1/reports/product_rest/?date_to=' + this.filterDate + '&store=' + this.filterStore;
        }
        else if(this.selectReport === 'period_report') {
            url = server_addr + '/api/v1/periodic_report?date_from=' + this.filterDate[0] + '&date_to=' + this.filterDate[1] + '&store=' + this.filterStore;
        }
        else if(this.selectReport === 'period_payment') {
            url = server_addr + '/api/v1/payment_report?date_from=' + this.filterDate[0] + '&date_to=' + this.filterDate[1] + '&store=' + this.filterStore + '&isFiscal=true';
        }
        else if(this.selectReport === 'period_noFiscal_payment') {
            url = server_addr + '/api/v1/payment_report?date_from=' + this.filterDate[0] + '&date_to=' + this.filterDate[1] + '&store=' + this.filterStore + '&isFiscal=' + !this.isNoFiscalPressed;
        }
        else {
            url = server_addr + '/api/v1/reports/product_purchase/?date_from=' + this.filterDate[0] + '&date_to=' + this.filterDate[1] + '&store=' + this.filterStore;
        }


        this.$http({
            url: url,
            method: "get",
            responseType: "blob" // important
        })
            .then(response => {
                const blob = new Blob([response.data], {type: "application/octet-stream;charset=utf-8"});

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                a.download = `business-report.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка. Попробуйте позже.");
            })
            .finally(() => {
                this.loading = false;
            })
    };


    base.computed.displayChart = function () {
        return this.dataPayment.reduce((a, b) => a + b, 0) !== 0;
    };
    base.computed.displayTable = function () {
        return this.dataProducts.length !== 0
    };

    base.computed.daterange = function () {
        if (this.selectReport === 'period_wirehouse') {
            this.filterDate = '';
            return 'date';
        }
        else {
            this.filterDate = [];
            return 'daterange';
        }
    };


    base.mounted = function () {
        this.getUsers();
        this.getStore();
        this.getTotalCounts();
        this.getDetails(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchRevenue(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchPayments(this.filterCashier, this.filterStore, this.filterDate);
        this.fetchProducts(this.filterCashier, this.filterStore, this.filterDate);
    };


    base.watch.selectReport = function () {
        this.isValidPoints(this.filterDate, this.filterStore);
    };
    base.watch.filterDate = function () {
        this.isValidPoints(this.filterDate, this.filterStore);
    };
    base.watch.filterStore = function () {
        this.isValidPoints(this.filterDate, this.filterStore);
    };


    export default base;

</script>

<style scoped>
    .noFiscalButton {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 0px;
        padding: 0;
        margin-top: 5px;
        background-color: #fffcfc;
    }

    .noFiscalButton.pressed {
        border: 2px solid rgb(183, 233, 253);
    }
    .cards .card-container {
        text-align: center;
        padding: 15px 30px;
    }

    .graph-container .card-container {
        padding: 30px;
    }

    .card-container.box h2, .card-container.box h3 {
        color: #ffffff
    }

    .card-container.box p {
        color: rgba(255, 255, 255, 0.7);
    }

    .card-container.box-1 {
        background-color: #C450C4;
    }

    .card-container.box-2 {
        background-color: #25D77E;
    }

    .card-container.box-3 {
        background-color: #5087DE;
    }

    .card-container.box-4 {
        background-color: #FFB12C;
    }

    .cards .card-container h3 {
        margin-bottom: 5px;
    }

    .cards .card-container h2 {
        font-size: 22px;
    }

    .cards .card-container p {
        text-align: center;
        margin-bottom: 5px;
    }

    .box-count-circle {
        display: inline-block;
        width: 16px;
        height: 16px;
        -webkit-border-radius: 25px;
        -moz-border-radius: 25px;
        border-radius: 25px;
        margin-right: 10px;

        /*background: red;*/
    }

    .box-count-label {
        font-weight: bold;
    }


    .box-table-header {
        font-size: 15px;
        text-align: center;
        margin: 30px 0 20px 0;
        color: grey;
    }

    .box-table-row {
        text-align: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
        padding: 13px;
        border-radius: 20px;
        position: relative;
        font-size: 15px;
        margin: 20px 0;
        /*text-align: left;*/
    }


    .box-no-data {
        font-size: 20px;
        color: #80808094;
        margin: 80px;
    }


    @media screen and (max-width: 1900px) {
        .cards .card-container {
            padding: 15px 10px;
        }

        .box-table-row, .box-table-header {
            font-size: 14px;
        }

        .cards .card-container h2 {
            font-size: 22px;
        }
    }

    @media screen and (max-width: 1500px) {
        .cards .card-container {
            padding: 15px 5px;
        }

        .box-table-row, .box-table-header {
            font-size: 13px;
        }

        .cards .card-container h2 {
            font-size: 20px;
        }
    }

    @media screen and (max-width: 991px) {
        .w-lg-100 {
            width: 100%;
        }

        .datepicker_input {
            width: 100%;
        }

        .cards .card-container h2 {
            font-size: 18px;
        }
    }


    @media (min-width: 992px) {
        .ivu-col-span-lg-0 {
            display: block;
            width: auto;
        }

    }


</style>


<style>
    .ivu-date-picker input {
        width: 260px;
    }

    @media screen and (max-width: 991px) {
        .ivu-date-picker {
            width: 100%;
        }

        .ivu-date-picker input {
            width: 100%;
            max-width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/apps/report/businessGraphics.vue